import type { AdminRouterContext } from '@/lib/router-context'
import { createFileRoute, notFound, Outlet, redirect } from '@tanstack/react-router'

export function guardPhoneClickReport({
  context,
  params,
}: {
  context: Pick<AdminRouterContext, 'ability'>
  params: { orgId: number }
}): void {
  if (!context.ability.can('list', 'transactions')) throw notFound()

  if (+params.orgId === Number(import.meta.env.VITE_TUKIOS_FLOWERS_ORG_ID)) {
    throw redirect({
      to: '/$orgId/reports',
      params: { orgId: params.orgId },
    })
  }
}

export const Route = createFileRoute('/_authenticated/$orgId/reports/phone-clicks')({
  component: PhoneClickReportLayout,
  loader: guardPhoneClickReport,
})

function PhoneClickReportLayout() {
  return <Outlet />
}
